module.exports = __webpack_public_path__ + "settings-dark.png?cb4519ffae968a0273a87685bac9aa1f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/settings-dark.png
// module id = 1011
// module chunks = 2